module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_career_text_sm-02b1312426b7817c9cdf17cc035818f2.svg";